import React from 'react';
import { Container } from './Container';
type FooterLink = {
  label: string;
  href: string;
  external?: boolean;
};
const cols: {
  title: string;
  links: FooterLink[];
}[] = [{
  title: 'Products',
  links: [{
    label: 'Pigeon Documents',
    href: 'https://www.pigeondocuments.com',
    external: true
  }, {
    label: 'Pigeon Immigration',
    href: 'https://www.pigeonimmigration.com',
    external: true
  }, {
    label: 'Pigeon Logistics',
    href: 'https://www.pigeononboarding.com',
    external: true
  }, {
    label: 'Pigeon Follow-Ups',
    href: 'https://www.pigeonfollowups.com',
    external: true
  }]
}, {
  title: 'Company',
  links: [{
    label: 'Privacy Policy',
    href: 'https://pigeondocuments.com/privacy-policy',
    external: true
  }, {
    label: 'Terms of Service',
    href: 'https://pigeondocuments.com/terms-of-service',
    external: true
  }]
}, {
  title: 'Resources',
  links: [{
    label: 'API',
    href: 'https://docs.pigeondocuments.com/',
    external: true
  }, {
    label: 'Support',
    href: 'https://pigeondocuments.com/support',
    external: true
  }, {
    label: 'Email Us',
    href: 'mailto:info@pigeondocuments.com'
  }]
}];
export function Footer() {
  return <footer className="border-t border-white/[0.06] bg-zinc-950 py-12 sm:py-16" data-id="element-18">
      <Container data-id="element-19">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_3fr] lg:gap-12" data-id="element-20">
          <div data-id="element-21">
            <a href="/" className="flex items-center gap-2 rounded-md outline-none focus-visible:ring-2 focus-visible:ring-accent/50" data-id="element-22">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3Ti5Jr9Zm1LRNz51qTKsea/1.png" alt="Pigeon" className="h-7 w-auto" data-id="element-23" />
              <span className="text-2xl font-bold leading-none tracking-tight text-white" data-id="element-24">
                Pigeon
              </span>
            </a>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-zinc-400" data-id="element-25">
              Automate follow-ups and paper chasing for insurance brokers,
              wholesalers, and MGAs.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3 sm:gap-8" data-id="element-26">
            {cols.map(c => <div key={c.title} data-id="element-27">
                <div className="eyebrow text-zinc-500" data-id="element-28">{c.title}</div>
                <ul className="mt-5 space-y-2.5" data-id="element-29">
                  {c.links.map(l => <li key={l.label} data-id="element-30">
                      <a href={l.href} {...l.external ? {
                  target: '_blank',
                  rel: 'noopener noreferrer'
                } : {}} className="rounded text-sm text-zinc-300 outline-none transition-colors hover:text-white focus-visible:ring-2 focus-visible:ring-accent/50" data-id="element-31">
                        {l.label}
                      </a>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-white/[0.06] pt-6 font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500 sm:mt-16 sm:flex-row sm:items-center" data-id="element-32">
          <div data-id="element-33">© 2026 Pigeon Documents. All rights reserved.</div>
        </div>
      </Container>
    </footer>;
}